/* eslint-disable react/prop-types */
import ExclamationDangerIconWithBG from '@/components/svg/exclamationDangerIconWithBG'
import { Button } from '@/components/ui/button'
import { DialogActions } from '@mui/material'
import React from 'react'

function ConfirmDelete({resourceName, onCancel, onConfirm, handleCloseModal}) {
  return (
    <div>
              <div className='text-center flex justify-center items-center mb-3 '>
        <ExclamationDangerIconWithBG
          width={"5rem"}
          height={"5rem"}
          className='my-3'
        />
      </div>
      <h2 className='fs-20 leading-[2.8rem] fw-500 text-foreground text-center'>
        Delete {resourceName} ?
      </h2>
      <p className='fs-16 max-w-[45rem] leading-[2.5rem] py-5 fw-400 text-center m-auto text-foreground/70 normal-case'>
             Are you sure you want to delete this {resourceName} permanently? This
        action cannot be undone.
      </p>
      <DialogActions sx={{ padding: "0px", marginTop: "1.2rem" }}>
        <div className='flex justify-center items-center gap-4 w-[100%] mt-5'>
          <div className=''>

              <Button 
            variant="outline"
            className="text-[1.4rem] py-7 px-8 rounded-xl"
            onClick={onCancel ? onCancel : handleCloseModal}
            >
              Cancel
            </Button>

          </div>
          <div className=''>
            <Button 
            variant="destructive"
            className="text-[1.4rem] py-7 px-8 rounded-xl"
            onClick={onConfirm}
            >
              Yes, Remove
            </Button>
          </div>
        </div>
      </DialogActions>

    </div>
  )
}

export default ConfirmDelete